/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetIntelligentAppletsRequest} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/intelligent_applets_messages.pb'
import {GetIntelligentAppletsResponse} from '@cash-web/protos/squareup/cash/cashfrontdoor/api/v1beta1/intelligent_applets_messages.pb'


export const getIntelligentApplets = (request: GetIntelligentAppletsRequest, options?: CashRequestOptions) => post<GetIntelligentAppletsRequest, GetIntelligentAppletsResponse>("/cash-app/frontdoor/get-intelligent-applets", request, {...options, rejectOnError: true })